import { render, staticRenderFns } from "./Frettir.vue?vue&type=template&id=7ca3fef0"
import script from "./Frettir.vue?vue&type=script&lang=js"
export * from "./Frettir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports